import { useEffect, useMemo, useState } from 'react';
import { PaginationOptions, SetPage, SetTotalCount } from './interfaces';
import { INITIAL_PAGE_SIZES, usePaginationQuery } from './lib';

interface Options {
    /** default: 1*/
    initialPage?: number;
    /** default: 10*/
    initialPageSize?: number;
    /** default: 0*/
    firstAPIPage?: number;
    /** default: [5, 10, 20, 30, 40, 50]*/
    allowedPageSizes?: number[];
    /** default: true*/
    querySensibility?: boolean;
    /** default: 'page'*/
    pageQueryName?: string;
    /** default: 'pageSize'*/
    pageSizeQueryName?: string;
}

interface Returned {
    page: number;
    setPage: SetPage;
    pageSize: number;
    totalCount: number;
    setTotalCount: SetTotalCount;
    /** ! use this prop only for Paginator*/
    paginationOptions: PaginationOptions;
}

export function usePagination(options?: Options): Returned {
    const initialPage = options?.initialPage ?? 1;
    const initialPageSize = options?.initialPageSize ?? 10;
    const firstAPIPage = options?.firstAPIPage ?? 1;
    const querySensibility = options?.querySensibility ?? true;
    const pageQueryName = options?.pageQueryName || 'page';
    const pageSizeQueryName = options?.pageQueryName || 'pageSize';

    const [totalCount, setTotalCount] = useState<number | null>(null);

    const { queryPage, queryPageSize, setQueryPage, setQueryPageSize } = usePaginationQuery({
        initialPage,
        initialPageSize,
        totalCount,
        pageQueryName,
        pageSizeQueryName,
        querySensibility,
    });

    const [page, setPage] = useState<number>(querySensibility ? queryPage : initialPage);
    const [pageSize, setPageSize] = useState<number>(querySensibility ? queryPageSize : initialPageSize);

    const pageCount = useMemo(() => {
        return Math.ceil((totalCount ?? 0) / pageSize);
    }, [totalCount, pageSize]);

    useEffect(() => {
        if (querySensibility) setPage(queryPage);
    }, [queryPage, querySensibility]);

    useEffect(() => {
        if (querySensibility) setPageSize(queryPageSize);
    }, [queryPageSize, querySensibility]);

    // useEffect(() => {
    //     if (querySensibility) setQueryPage(page);
    // }, [page, querySensibility]);

    // useEffect(() => {
    //     if (querySensibility) setQueryPageSize(pageSize);
    // }, [pageSize, querySensibility]);

    return {
        page: page - (1 - firstAPIPage),
        setPage,
        pageSize,
        totalCount: totalCount ?? 0,
        setTotalCount,
        paginationOptions: {
            page,
            pageSize,
            totalCount: totalCount ?? 0,
            setPage,
            setPageSize,
            pageCount,
            pageSizes: options?.allowedPageSizes || INITIAL_PAGE_SIZES,
        },
    };
}

export function usePagination2(options?: Options): Returned {
    const initialPage = options?.initialPage ?? 1;
    const initialPageSize = options?.initialPageSize ?? 10;
    const firstAPIPage = options?.firstAPIPage ?? 1;
    const querySensibility = options?.querySensibility ?? true;
    const pageQueryName = options?.pageQueryName || 'page';
    const pageSizeQueryName = options?.pageQueryName || 'pageSize';

    const [totalCount, setTotalCount] = useState<number | null>(null);

    const { queryPage, queryPageSize, setQueryPage, setQueryPageSize } = usePaginationQuery({
        initialPage,
        initialPageSize,
        totalCount,
        pageQueryName,
        pageSizeQueryName,
        querySensibility,
    });

    const [page, setPage] = useState<number>(querySensibility ? queryPage : initialPage);
    const [pageSize, setPageSize] = useState<number>(querySensibility ? queryPageSize : initialPageSize);

    const pageCount = useMemo(() => {
        return Math.ceil((totalCount ?? 0) / pageSize);
    }, [totalCount, pageSize]);

    useEffect(() => {
        if (querySensibility) setPage(queryPage);
    }, [queryPage, querySensibility]);

    useEffect(() => {
        if (querySensibility) setPageSize(queryPageSize);
    }, [queryPageSize, querySensibility]);

    // useEffect(() => {
    //     if (querySensibility) setQueryPage(page);
    // }, [page, querySensibility]);

    // useEffect(() => {
    //     if (querySensibility) setQueryPageSize(pageSize);
    // }, [pageSize, querySensibility]);

    return {
        page: page - (1 - firstAPIPage),
        setPage,
        pageSize,
        totalCount: totalCount ?? 0,
        setTotalCount,
        paginationOptions: {
            page,
            pageSize,
            totalCount: totalCount ?? 0,
            setPage,
            setPageSize,
            pageCount,
            pageSizes: options?.allowedPageSizes || INITIAL_PAGE_SIZES,
        },
    };
}
